module.exports = __webpack_public_path__ + "img/purchases--avatar.128d326a.svg";